<template>
    <split-pane  :min-percent='10' :default-percent='35' split="vertical" style="background:white; height:100%"> 
        <template slot="paneL">
            <div style="min-width:520px;background:white;line-height:30px;border-bottom:1px solid #ccc;padding-left:2px;display:flex">
                <div style="line-height:30px;margin-left:5px;margin-right:4px;font-size:12px;font-weight:600">{{ $LANG('0120', '查询字段') }}</div>
                <el-select v-model="selparam" @change="selChg"  placeholder="请选择列名" filterable size="small" style="width:100px;  ">
                    <span v-for="item in bomArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input v-if="v_bool" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryBomData('')" size="small" style="width:290px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryBomData('')" ></el-button>
                </el-input> 
                <el-select v-if="!v_bool"   @change="qryBomData('')" clearable size="small" v-model="txtparam"  style="width:240px; height:30px; ">
                    <el-option v-for="(item,index) in tyArr" :key="index" :label="item.MATTYNM" :value="item.MATTYNM" ></el-option>
                </el-select>
                <el-checkbox label="显示冻结" size="mini" true-label="Y" false-label="N" v-model="v_hide" @change="qryBomData('')" style="margin-left:10px;color:#ff0000;font-size:12px;line-height:30px;margin-top:4px"></el-checkbox>
            </div>
            <div style="display:flex;line-height:25px ;  "> 
                <div  class="oneMenu" @click="itemClick('one')">
                    <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                        <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i> 已量产(大于100)</div>
                </div>
                <div  class="oneMenu" @click="itemClick('two')">
                    <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                        <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>已量产(小于100)</div>
                </div>
                <div  class="oneMenu" @click="itemClick('three')">
                    <div style="margin-left:40px" :class="{active: actitem==='three'}" >
                        <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>未量产(=0) </div>
                </div>
            </div>
          
            <el-table  :data="bomData" 
                border                            
                disabled-hover
                class="custom-table-border"
                :cell-style="{padding:'2px','font-size':'12px'}"
                style="overflow:auto;margin-top:1px;"
                size="small"
                header-cell-class-name="clearPadding"
                :row-class-name="bomRowClass"
                v-loading="v_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                @row-click="rowClick"
                :height="bomHeight" 
                ref="refjob" 
                highlight-current-row>
                <el-table-column label="序号" type="index" width="55" fixed>
                    <el-table-column label="序号" type="index" width="55" fixed>
                        <template slot="header"  >
                            <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                <el-tooltip content=" 清除条件" effect="light">
                                    <i class="iconfont icon-shanchu1"  ></i>
                                </el-tooltip>
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-for="(item ,index) in bomArr.filter(item=>item.thide=='N')" :key="index"  
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                          
                    :sortable="item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryBomData('')" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                            <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryBomData('')"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                        </template>
                        <template slot-scope="scope">
                            <el-link v-if="item.key=='MATNO'" :underline="false" @click="repBtn(scope.row)">
                                <div style="border-bottom:1px solid red;width:100%;text-align:left;font-size:14px ">
                                    {{scope.row[item.key]}}
                                </div> 
                            </el-link>
                            <el-tag  v-else-if="item.key=='MBTY'&&scope.row['MBTY']=='A'" size="mini" type="success" effect="dark">量产</el-tag>
                            <el-tag  v-else-if="item.key=='MBTY'&&scope.row['MBTY']=='B'" size="mini" type="danger" effect="dark">成型未量产</el-tag>                         
                            <el-tag  v-else-if="item.key=='MBTY'&&scope.row['MBTY']=='C'" size="mini" type="info" effect="dark">草稿</el-tag>  
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column>
                </el-table-column>             
            </el-table> 
 
            <!-- 分页查询 -->
            <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;min-width:150px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <!-- <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button> -->
            </div>
        </div>
        </template>
        <template slot="paneR">
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                    <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <div slot="footer">
                    <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
                </div>
            </el-dialog>

            <!-- 分类表格
                :data(设置数据源) :columns(设置表格中列配置信息) :selection-type(是否有复选框)
                :expand-type(是否展开数据) show-index(是否设置索引列) index-text(设置索引列头)
                border(是否添加纵向边框) :show-row-hover(是否鼠标悬停高亮) -->
            <div class="one-toolbar" style="display:flex">
                <span class="spanRow">合计成本(不含客供)：¥ {{v_cost}} （物料成本：{{v_matcost}} , 制造费用：{{v_prdcost}}）</span>
                <el-tooltip>
                    <el-button type="danger" size="mini" @click="exePrc" style="margin-left:20px;height:30px;margin-top:2px" icon="iconfont icon-shuaxin">刷新单价</el-button>
                    <span slot="content" style="font-weight:600;font-size:13px;color:#fff;margin-left:15px">{{v_rmk}} </span>
                </el-tooltip>
                <span style="font-weight:600;font-size:13px;color:#fff;margin-left:15px">采购价: <span style="color:green">绿色</span> , 询价: <span style="color:blue">蓝色</span> ,手输价: <span style="color:red">红色</span> </span>
            </div>    
            <el-table  :data="dtlData" 
                    border                            
                    disabled-hover 
                    style="overflow:auto;margin-top:-10px;"
                    size="small"
                    :cell-style="cellStyle" 
                    :header-cell-style="{'padding':'4px','background':'#389','color':'white'}"
                    :height="dtlHeight"           
                    ref="reftree" 
                    row-key="usetool"                 
                    default-expand-all
                    :row-class-name="tabRowClass"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
                    class="custom-table-border"
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row>
                <!-- <el-table-column label="序号" type="index" width="55" ></el-table-column> -->
                <el-table-column label="产品树状BOM" prop="label" :min-width="260" :show-overflow-tooltip="true" align="left"></el-table-column>
                <el-table-column  v-for="(item,index ) in treeCol.filter(item=>item.thide=='N'&&item.key!=='label' )" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                           
                    :min-width="item.width">
                    <template slot-scope="scope">                                        
                        <el-link @click="btnPrc(scope.row)" v-if="item.key=='prc'" :underline="false"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row[item.key]}}</span></el-link> 
                        <el-link @click="btnJob(scope.row)" v-else-if="item.key=='matno' && !scope.row['mattynm'] &&scope.row['lstseq']!=='0'" :underline="false" style="float:left"><div style="border-bottom:1px solid red;font-size:12px;text-align:left">{{scope.row[item.key]}}</div></el-link> 
                        <div v-else v-text="scope.row[item.key]" style="float:left;text-overflow:ellipsis;overflow: hidden;white-space:nowrap;width:100%;text-align:left"> </div>
                    </template>
                </el-table-column>
     
            </el-table> 
            <!-- report preview -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>

            <!-- 引用报表 -->
            <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
                </div> 
                <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
            </el-dialog>
            <!-- 变更物料类型--> 
            <el-dialog v-dialogDrag :visible.sync="propWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">变更制造属性</span>
                </div>    
                <div style="line-height:35px;height:50px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">工序名称</div>
                    <el-input size="medium" disabled  v-model="v_label" style="width:320px;background:#f7f8f9"></el-input>
                </div>
                <div style="line-height:35px;height:50px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">物料属性</div>
                    <el-select @change="propChg(v_prop)" v-model="v_prop" placeholder="请选择" size="medium" style="width:320px">
                        <el-option label="自制" value="IN"></el-option>
                        <el-option label="委外" value="OUT"></el-option>
                        <el-option label="客供" value="CLNT"></el-option>
                    </el-select>
                </div>
                <div style="line-height:35px;height:50px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px; ">委外供应商</div>
                    <el-select v-model="v_supno" filterable :disabled="supFlag" placeholder="请选择" size="medium" style="width:320px">
                        <span v-for="(item,index) in supArr" :key="index">
                            <el-option :label="item.SUPNM" :value="item.IDSEQ"  ></el-option>
                        </span>
                    </el-select>
                </div>
                <div style="line-height:35px;height:50px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">制造费用 / 件</div>

                    <el-input  type="number" @keydown.native="e=>e.returnValue=(['e','E','+','-'].includes(e.key))?false:e.returnValue"     size="medium"  :controls="false"  v-model="v_fee" style="width:320px"> </el-input> 
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="propWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" icon="iconfont icon-yiqueren-xianxing"  size="small" @click="propSure" style="margin-right:12px;">确定</el-button>
                    </span>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
            <!-- 单 价采购明细--> 
            <el-dialog v-dialogDrag :visible.sync="poWin" v-if="poWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">物料采购明细</span>
                </div> 
                <el-table  :data="poData" 
                        border          
                        class="custom-table-border"                  
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:0px;"
                        size="small"
                        v-loading="p_loading"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        :height="400" 
                        highlight-current-row>
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column  v-for="(item,index ) in poArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'"
                        :min-width="item.width">
                        <template slot-scope="scope" >
                            <span  v-if=" item.key==='ORDSTFG'"  > 
                                <el-tag v-if="scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                                <el-tag v-else  size="mini" type="danger" effect="dark">未审核</el-tag>
                            </span>
                             
                            <span v-else v-text="scope.row[item.key]"></span>
                        </template>
                    </el-table-column> 
                </el-table>
            </el-dialog>
        </template>
        
    </split-pane>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue' 
export default {
    name:'bom_cost',
    data () {
        return {
            poWin:false,
            v_row:{},
            t_row:{},
            bomCol:[],
            v_rmk:'',
            loadWin:false,
            supFlag:true,
            supArr:[],
            v_supno:'',
            v_fee:'',
            v_label:'',
            v_prop:'IN',
            propWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            v_cost:0.0000,
            v_matcost:'',
            v_prdcost:'',
            dataCount:0,
            rowSize:100,
            dtlRow:{},
            loading:false,
            dtlWin:false,
            comboArr:[],
            promptWin:false,
            t_loading:false,
            treeRow:{},
            prompt:'',
            input_hold:'请输入内容...',              
            selparam:'MATTYNM',
            textparam:'',
            goPage:'',
            bomData:[],
            pageList: [ {
                value: 100,
                label: '100'
                }, {
                value: 200,
                label: '200'
            }],
            current:1,
            repUrl:'',
            repWin:false,
            tyArr:[],
            allList:[], //询价单集合
            v_loading:false,
            dtlData:[],
            matData:[],
            v_manyurl:'xuper_auth/getBaseData' , //api请求路径      
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
           
            operArr:[],
            v_bool:false,
            oper:'like',
            parentno:'', 
            txtparam:'',
            bomArr:[],
            repArr:[],
            treeCol: [],
            v_hide:'N',
            v_idseq:'',
            v_lstseq:'',
            poArr:[],
            poData:[],
            p_loading:false,
            actitem:'one',
        }
    },
    components: {
        repWin,
    },
    computed: {
        dtlHeight: function() {
            return (window.innerHeight - 120) + 'px';
        }, 
 
        bomHeight: function() {
            return (window.innerHeight - 187) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 80) + 'px';
        },
    },
    mounted () {
        //供应商(委外制造类型)
        getBaseData(this.v_manyurl+'','CORPID',this.v_corpid ,'supty','399986','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        getBaseData(this.v_manyurl+'','CORPID',this.v_corpid ,'','','V_PRD_BOM_GP','').then(res=>{
            this.tyArr =res.result
        })
        
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        getBaseData(this.v_manyurl+'','userno',this.v_username,'frmidseq','17010','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        this.comSelect()
        this.getLog()
        this.qryBomData(' and ordqty>100')//工序明细
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        itemClick(val){
            this.actitem =val    
            let v_cond= val=='one'?' and ordqty>100':val=='two'?' and ordqty>0 and ordqty<100':' and ordqty=0'
            this.qryBomData(v_cond)
        },
        getPoList(matno){
            this.poWin=true    
            this.p_loading=true  
            this.poData=[] 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:matno,p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_po_orddtl',p_cond:' order by orddttm desc'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.poData=res.result
                    this.p_loading=false
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }) 
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            if (row.isGroupSummary ) {
              return 'subtotal-row'
            } 
        },
        bomRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            if (row['ORDQTY'] > 100) {  //订单数量
                return 'green-row';
            }else if (row['ORDQTY'] > 0 && row['ORDQTY'] <100) {  //订单数量
                return 'org-row';
            }else if (row['ORDQTY'] <=0) {  //订单数量
                return 'black-row';
            }
        },
        //单元格样式
        cellStyle({row,column}){
            if (row['refposeq'] && row['prc'] ){
                return {'padding-top':'3px','padding-bottom':'3px', 'color':'green'}
            }else if (row['refprcseq'] && row['prc'] ){
                return {'padding-top':'3px','padding-bottom':'3px', 'color':'blue'}
            }else if (!row['refposeq'] && !row['refprcseq'] && row['prc'] ){
                return {'padding-top':'3px','padding-bottom':'3px', 'color':'red'}
            }else{
                return {'padding-top':'3px','padding-bottom':'3px', 'color':'black'}
       
            } 
        },
        getLog(){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key: 'idseq',p_value: '17010', p_table:'V_BILL_LOG',p_cond:' order by dttm desc'  },
            }).then(res=>{ 
                if (res.result.length>0)
                this.v_rmk =' 最近更新单价日期：' +res.result[0]['DTTM'] //+' , 最近刷新用户：' +res.result[0]['STAFF']

            })
        },
  
        selChg(val){
            if(val =='MATTYNM'){
                this.v_bool =false
            }else{
                this.v_bool =true
            }
           
            this.txtArr1=[]
            this.txtparam=''
        },
        btnJob(row){
            this.propWin =true
            this.v_label =row['label']
            this.v_idseq =row.idseq
            this.v_lstseq =row.lstseq
            this.v_prop = row.stfg
            this.v_supno =row.supidno
            this.v_fee =row.hrcost
            if (row['stfg'] =='OUT'){ //委外
                this.supFlag =false
            }else{
                this.supFlag =true
            }
        },
        //变更物料属性
        propSure(){
            if (this.v_prop =='OUT' && !this.v_supno){
                this.promptWin =true
                this.prompt ='属性为 委外时，供应商不能为空'
            }else if (this.v_prop =='OUT' && !this.v_fee){
                this.promptWin =true
                this.prompt ='属性为 委外时，制造费用不能为空'
            }
            else {
                this.loadWin =true  //p_key:'idseq',p_value:this.v_idseq,p_key2:'lstseq',p_value2:this.v_lstseq,
                let v_cond =''
                if (this.v_supno ) {
                    v_cond = ' set stfg=\''+this.v_prop+'\',supno=\'' + this.v_supno +'\',OUTPRC='+this.v_fee
                }else {
                    v_cond = ' set stfg=\''+this.v_prop+'\',supno=null ,OUTPRC =' +this.v_fee
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_table:'PRD_BOMDTL',p_cond: v_cond,p_key:'idseq',p_value:this.v_idseq,p_key2:'lstseq',p_value2:this.v_lstseq},
                }).then(res=>{ 
                    this.getDtlList(this.v_idseq) 
                    this.loadWin =false
                    this.propWin =false
                })
            }
        },
        propChg(val){
            this.v_supno =''
            if (val =='OUT'){ //委外
                this.supFlag =false
            }else{
                this.supFlag =true
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['MATNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] +'&p_userid='+'COST'+this.v_username+getDate('full') 
            }
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.bomData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.bomData = this.allList          
            }else{
 
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.bomData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryBomData('')
        } ,
        qryBomData(t_cond){
            let cond_=' and stfg!=\'X\' ' ,v_edcss='',v_cond=''
            if (this.v_hide =='N'){
                cond_ =cond_+' and ishide=\'N\' '
            }else {
                cond_ =cond_+' and ishide=\'Y\' '
            }
            if (this.selparam){
                if (this.oper==='like'){
                    cond_=cond_+' and lower('+this.selparam+') like lower(\'%'+this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and lower('+this.selparam+')'+this.oper+'lower(\''+this.txtparam+'\')'
                }
            }
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.bomArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        cond_ =cond_ +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        cond_ =cond_ +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }
  
                }
            })
            this.getBomList(cond_+t_cond)
        },
        //工序明细
        getBomList(cond){        
            this.v_loading =true
            this.dtlData=[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by mattynm' ,p_table:'V_prd_bom'},
            }).then(res=>{ 
                if (res.code=='200') {
                    this.allList =res.result
                    this.initPage()
                    if (res.result.length>0){
                        this.$refs['refjob'].setCurrentRow(res.result[0])
                        this.t_row =res.result[0]
                        this.getDtlList(res.result[0]['IDSEQ'])
                        this.v_loading=false
                    }else{
                        this.v_loading =false
                    }
                }else {
                    this.promptWin =true
                    this.prompt =res.result
                }
            }) 
        },
        btnPrc(row){
            if (row['refposeq']){
                console.log(row['matno'],'...')
                this.getPoList(row['matno'])
                //this.repWin =true
                //this.repUrl =this.$store.state.repUrl +'rep_poord.cpt&p_idseq='+row['refposeq'] 
            }else if (row['refprcseq'] ) { //询价单
                this.repWin =true
                this.repUrl =this.$store.state.repUrl +'po_ask.cpt&p_idseq='+row['refprcseq'] 
            }else{
                this.promptWin =true
                this.prompt ='此价格来源是在基础资料中手工输入'
            }
            
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16532',p_cond:' and lstseq in (1,2 ,4)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        rowClick(row,column){
            //console.log(column)
            this.t_row =JSON.parse(JSON.stringify(row))
            if (column.property!=='MATNO2'){
                this.getDtlList(row.IDSEQ)  
            }
        },
        //刷新单价
        exePrc(){
            this.$confirm('你确定刷新单价记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //call_procedure
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/call_procedure',
                    data: {p_user:this.v_username,corpid:this.v_corpid,p_action:'COST' },
                }).then(res=>{ 
                    if (res.code=='200'){
                        this.getDtlList( this.t_row['IDSEQ'] ) 
                        this.getLog()
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }
                })
            }).catch(()=>{})
        },
        // 明细  'xuper_auth/getBaseData' 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading =true
            this.v_cost=0.0000
            this.v_matcost=''
            this.v_prdcost=''
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getMrpTreeData',
                data: {p_key:'idseq',p_value:idseq,p_key2:'corpid',p_value2:this.v_corpid,p_table:'V_PRD_BOMDTL_TREE',p_cond:' order by jobnum'},
            }).then(res=>{ 
                if (res.code=='200') {
                    let rawData =res.result
                    this.processTreeData(rawData)
                    this.$nextTick(()=>{
                        this.$refs['reftree'].doLayout()
                        this.t_loading=false
                    })
                    // 去掉 客供料成本
                    let v_cond =' and parentno not in (select matno from prd_bomdtl where jobno=\'900291\' and idseq='+idseq+')'
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getFreeData',
                        data: { p_cond:'select sum(NVL(AMT,0))+sum(nvl(hrcost,0)) AMT,sum(NVL(AMT,0)) MATCOST,sum(nvl(hrcost,0)) PRDCOST from V_PRD_BOMDTL_TREE where idseq=\''+idseq+'\''+v_cond},
                    }).then(res=>{ 
                        if (res.result[0] ) {
                            this.v_cost =res.result[0]['AMT']
                            this.v_matcost =res.result[0]['MATCOST']
                            this.v_prdcost =res.result[0]['PRDCOST']
                        }
                    })
                }
            }) 
        },
 
        //处理树形数据，计算每层的金额小计
        processTreeData(data) {
            if (!data || !data.length) return;
            const calculateTotalAmt = (node) => {
                if (!node.children || node.children.length === 0) {
                // 叶子节点直接返回自身金额
                return parseFloat(node.amt || 0);
                }   
                // 计算所有子节点的总金额（递归）
                let childrenTotal = 0;
                for (const child of node.children) {
                // 排除小计行
                if (!child.isGroupSummary) {
                    childrenTotal += calculateTotalAmt(child);
                }
                } 
                return childrenTotal 
            }
            const processNode = (node) => {
                // 如果没有子节点，直接返回
                if (!node.children || node.children.length === 0) {
                return node;
                }
                
                // 递归处理子节点
                node.children.forEach(child => processNode(child));
                
                // 移除可能已存在的小计行
                node.children = node.children.filter(child => !child.isGroupSummary);
                
                // 计算该节点所有子孙节点的金额总和
                const totalAmt = calculateTotalAmt(node);
                
                // 添加小计行
                if (node.children.length > 0) {
                    node.children.push({
                        usetool: Math.random(),
                        amt: totalAmt.toFixed(4),
                        matno: '',
                        isGroupSummary: true,
                        label: '小计'
                    });
                }               
                return node
            }
        
            // 处理每个顶级节点
            this.dtlData = data.map(node => processNode(node));
        },
        getRowKey(row){
            return row.IDSEQ
        },
  
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(vm.v_manyurl,'v_sys_form_fld','idseq','17010','lstseq','1','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.bomArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17010','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.treeCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: (res.result[k].key).toLowerCase(),
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15691','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:10px;
        }   
    }
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
  <style lang="less">
    .el-table .subtotal-row {
        font-weight: bold;
        background-color: #f0f9eb;
        color:red !important;
    }
    .el-table .green-row {
        font-weight: bold;
        background-color: #fff;
        color:green!important;
    }
    .el-table .org-row {
        font-weight: bold;
        background-color: #fff;
        color:orange!important;
    }
    .el-table .black-row {
        font-weight: bold;
        background-color: #fff;
        color:black!important;
    }
    .el-icon-arrow-right {
        color:#ff0000;
    }
    .el-table .el-table__expand-icon{
        .el-icon-arrow-right:before{
            content: '\e791';
        }
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
  
 </style>